import * as React from 'react';
import {styled} from '@mui/material/styles';
import MuiAccordion, {AccordionProps} from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import {PiCircleFill} from 'react-icons/pi';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {ChevronDown} from '@jobseeker/lotus/icons';
const accordionsData = [
  {
    title: 'Introduction (5-10 secs)',
    body: 'Start with a short introduction. Tell your name, talk about your current role, your qualifications, your years of experience.',
  },
  {
    title: 'Background (5-10 secs)',
    body: "Talk about your work experience, the kind of responsibilities you've handled or the projects you've worked upon. Talk about your skills and what you excel at.",
  },
  {
    title: 'Keyhighlights (5-10 secs)',
    body: "Talk about something that's unique to you. Any key project that you handled and how contributed or made an impact. Your achievements or what you are passionate about. You can also talk about your favorite professional experience, what you learned and how it helped you grow. Use this time to hook the recruiters and tell your story.",
  },
  {
    title: 'Summarise (5-10 secs)',
    body: 'You can end with what makes you a good fit for your role. Or you can talk about what kind of opportunities you are looking for. Thank the recruiter for their time and end with an action statement.',
  },
];

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
  padding: 0,
  border: 0,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <Image
        src={ChevronDown}
        width={10}
        height={10}
        alt=""
        // sx={{fontSize: 5, color: 'text.primary', mx: 1}}
      />
    }
    {...props}
  />
))(({theme}) => ({
  margin: theme.spacing(1, 2),
  padding: 0,
  minHeight: 'unset',
  // marginBottom: 0,
  // '&:last-child': {
  //   marginBottom: theme.spacing(1.5),
  // },
  // '&.Mui-expanded': {
  //   marginBottom: 0,
  // },
  // flexDirection: 'row-reverse',
  // '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
  //   transform: 'rotate(90deg)',
  // },
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
  padding: theme.spacing(0, 2),
  paddingLeft: theme.spacing(4),
  // borderTop: '1px solid rgba(0, 0, 0, .125)',
  marginTop: theme.spacing(-1),
  lineHeight: '16px',
}));

const TitleComponent = ({title}: any) => (
  <Typography
    variant="subtitle3"
    fontWeight={600}
    display={'flex'}
    alignItems={'center'}
    gap={1}
  >
    <Box component={PiCircleFill} sx={{fontSize: 6}} /> {title}
  </Typography>
);

export const AccordionGroup = (props: any) => {
  const [expanded, setExpanded] = React.useState<string | false>('panel1');

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <div>
      {(props.accordions || accordionsData).map((acc: any, index: number) => (
        <Accordion
          expanded={expanded === `panel${index + 1}`}
          onChange={handleChange(`panel${index + 1}`)}
        >
          <AccordionSummary
            aria-controls={`panel${index + 1}d-content`}
            id={`panel${index + 1}d-header`}
          >
            <TitleComponent title={acc.title} />
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body3" color={'text.secondary'}>
              {acc.body}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default AccordionGroup;
